import styled from 'styled-components';
import { s4 } from '@ardoq/design-tokens';
import { TAG_BUTTON_SELECTOR, TAG_DIV_SELECTOR } from './atoms';

const SPACING = s4;

export const TagGroup = styled.div`
  margin-top: -${SPACING};
  margin-left: -${SPACING};

  ${TAG_DIV_SELECTOR}, ${TAG_BUTTON_SELECTOR} {
    margin-top: ${SPACING};
    margin-left: ${SPACING};
  }
`;
